import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, IconButton, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import Subtract from '@mui/icons-material/Remove';
import { addOpacity } from './helpers';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    border: `1px solid ${addOpacity(theme.palette.text.primary, 0.08)}`,
    borderRadius: '9999px', // Pill Shape
    alignItems: 'center',
    width: 'max-content',
    marginBottom: theme.spacing(1)
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.primary.main
}));

interface IQuantitySelectProps {
    min: number;
    max: number;
    quantity: number;
    onChange: (quantity: number) => void;
    disabledMax?: boolean;
}

export const QuantitySelector: React.FC<React.PropsWithChildren<IQuantitySelectProps>> = props => {
    const { min, max, quantity, onChange, disabledMax } = props;

    const minusQuantity = React.useCallback(() => {
        if (quantity !== min) {
            onChange(quantity - 1);
        }
    }, [onChange, min, quantity]);
    const addQuantity = React.useCallback(() => {
        if (quantity !== max) {
            onChange(quantity + 1);
        }
    }, [onChange, max, quantity]);

    return (
        <StyledBox>
            <StyledIconButton
                disabled={quantity === 0}
                aria-label="Subtract Quantity"
                onClick={minusQuantity}
                size="large"
            >
                <Subtract />
            </StyledIconButton>
            <Typography variant="subtitle1">{quantity}</Typography>
            <StyledIconButton
                disabled={disabledMax}
                aria-label="Add Quantity"
                color="primary"
                onClick={addQuantity}
                size="large"
            >
                <Add />
            </StyledIconButton>
        </StyledBox>
    );
};
